/** @lint */

/**
 * @module orb/features/_searchhint
 */
define('orb/features/_searchhint', ['orb/lib/_$'], function ($) {
    'use strict';
    
    /**
        Introduce search placeholder behaviour for older browsers.
        @author Robin Murphy
        @author Gemma Clitheroe
     */ 
    return function () {
        var supportsPlaceholderAtrribute = ('placeholder' in document.createElement('input'));

        if (!supportsPlaceholderAtrribute) {
            var searchInput = $('#orb-search-q')[0],
                searchForm = $('#orb-search-form')[0],
                placeholderText = $.getAttr(searchInput, 'placeholder');

            $.ready(function () {

                $.addEvent(searchInput, 'focusout', function (e) {
                    if (searchInput.value === '') {
                        searchInput.value = placeholderText;
                    }
                });

                $.addEvent(searchInput, 'focusin', function (e) {
                    if (searchInput.value === placeholderText) {
                        searchInput.value = '';
                    }
                });

                $.addEvent(searchForm, 'submit', function (e) {
                    if (searchInput.value === placeholderText) {
                        searchInput.value = '';
                    }
                });

                // Only adds placeholder text if input field is not
                // active element (has focus)
                if (!searchInput.value && document.activeElement !== searchInput) {
                    searchInput.value = placeholderText;
                }
                
            });
        }
    };
});
    